import { useEffect, useRef } from 'react';

export default function MapView({ lat, lng }) {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);

  useEffect(() => {
    if (!lat || !lng) return;

    // Simple fallback map using OpenStreetMap tiles
    const initMap = () => {
      if (mapInstanceRef.current) return;

      const mapContainer = mapRef.current;
      if (!mapContainer) return;

      // Create a simple static map image using OpenStreetMap
      const zoom = 13;
      const width = 800;
      const height = 400;
      
      mapContainer.innerHTML = `
        <div class="relative w-full h-64 bg-gray-100 rounded-lg overflow-hidden">
          <iframe
            width="100%"
            height="100%"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            src="https://www.openstreetmap.org/export/embed.html?bbox=${lng-0.01},${lat-0.01},${lng+0.01},${lat+0.01}&layer=mapnik&marker=${lat},${lng}"
            style="border: none"
          ></iframe>
        </div>
      `;
      
      mapInstanceRef.current = true;
    };

    initMap();
  }, [lat, lng]);

  if (!lat || !lng) {
    return <div className="text-gray-500 text-center py-8">No location data available</div>;
  }

  return (
    <div data-testid="map-view">
      <div ref={mapRef} className="w-full h-64 rounded-lg" />
      <div className="mt-2 text-sm text-gray-600">
        Coordinates: {lat.toFixed(6)}, {lng.toFixed(6)}
      </div>
    </div>
  );
}